<template>
  <v-container>
    <v-row
      v-for="item in participantItems"
      :key="item.customerVariable.customerVariableId"
    >
      <v-col
        cols="10"
      >
        <v-text-field
          v-if="item.attribute.type===0 && (!item.customerVariable.hidden || !$route.path.startsWith('/common'))"
          v-model="item.userVariable.value"
          outlined
          :label="item.customerVariable.nickname"
          :hint="item.customerVariable.hint"
          :placeholder="item.customerVariable.hint"
          :readonly="item.customerVariable.readonly && $route.path.startsWith('/common')"
          :rules="[value => !!value || !item.customerVariable.mandatory || item.customerVariable.validateText]"
          @keyup="onKeyDown"
        />
        <v-text-field
          v-if="item.attribute.type===1 && (!item.customerVariable.hidden || !$route.path.startsWith('/common'))"
          v-model="item.userVariable.value"
          outlined
          type="number"
          :label="item.customerVariable.nickname"
          :hint="item.customerVariable.hint"
          :placeholder="item.customerVariable.hint"
          :readonly="item.customerVariable.readonly && $route.path.startsWith('/common')"
          :rules="[value => !!value || !item.customerVariable.mandatory || item.customerVariable.validateText]"
        />
        <v-checkbox
          v-if="item.attribute.type===2 && (!item.customerVariable.hidden || !$route.path.startsWith('/common'))"
          v-model="item.userVariable.value"
          :label="item.customerVariable.nickname"
          :hint="item.customerVariable.hint"
          :readonly="item.customerVariable.readonly && $route.path.startsWith('/common')"
          false-value="0"
          true-value="1"
        />
        <v-select
          v-if="item.attribute.type===5 && (!item.customerVariable.hidden || !$route.path.startsWith('/common'))"
          v-model="item.userVariable.value"
          outlined
          :label="item.customerVariable.nickname"
          :hint="item.customerVariable.hint"
          :readonly="item.customerVariable.readonly && $route.path.startsWith('/common')"
          :items="item.customerVariable.byDefault.split(';')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebApi from "@/views/loyalty/shared/modules/web_api"

export default {
  name: "UserProfileForm",
  model: {
    prop: 'attrSave',
    event: 'attrSaved'
  },
  props: {
    attrSave: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String,
      default: null
    },
    userProfileId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    participantItems: [],
    user_id: null,
    webApi: null
  }),
  watch: {
    attrSave () {
      if (this.attrSave === true) {
        console.log('save items', this.participantItems)
        this.saveItems()
        this.$emit('attrSaved')
      }
    },
    customerId: {
      async handler (newValue, oldValue) {
          console.log('customerId is changed', newValue)
        console.log(oldValue)
        if (!oldValue && this.customerId && this.userProfileId) {
          this.participantItems = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/user_variables/participant/${this.customerId}/${this.userProfileId}`)
          console.log('this.participantItems', this.participantItems)
          const isAllFieldFilled = this.participantItems.every(item => item.userVariable.value.length > 0)
          console.log('isAllFieldFilled:', isAllFieldFilled)
          this.$emit('fill', isAllFieldFilled)
          const isLoyaltyValidate = this.participantItems.every(item => {
            return this.getLoyaltyValidate(item)
          })
        }
        }
    },
      userProfileId: {
      async handler (newValue, oldValue) {
        console.log('userProfileId is changed', newValue)
        console.log(oldValue)
        if (this.customerId && this.userProfileId) {
          this.participantItems = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/user_variables/participant/${this.customerId}/${this.userProfileId}`)
          console.log('this.participantItems', this.participantItems)
          const isAllFieldFilled = this.participantItems.every(item => item.userVariable.value.length > 0)
          console.log('isAllFieldFilled:', isAllFieldFilled)
          this.$emit('fill', isAllFieldFilled)
          const isLoyaltyValidate = this.participantItems.every(item => {
            return this.getLoyaltyValidate(item)
          })
        }
      }
    }
  },
  async beforeMount () {
    this.webApi = new WebApi(this.$store)
    let id = this.$route.query.id
    if (!id && this.$route.path.indexOf('profile') > -1) {
      id = this.$store.state.user.id // если query не задан, то это профиль
    }
    console.log('id=' + id)
    console.log('user.id', this.$route.query.id)
      if (id) {
          this.participantItems = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/user_variables/participant/${this.$store.state.user.current_client}/${id}`)
      }
      if (!this.customerId) {
          this.customerId = localStorage.getItem('customer')
          this.customerNumber = localStorage.getItem('customerNumber')
      }
    console.log('customerId=' + this.customerId)
    console.log('userProfileId=' + this.userProfileId)
    console.log('participantItems=' + this.participantItems)
    // for users from UserProfile
    if (this.participantItems.length === 0 && this.customerId && this.userProfileId) {
      this.participantItems = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/user_variables/participant/${this.customerId}/${this.userProfileId}`)
        console.log('this.participantItems', this.participantItems)
        const isAllFieldFilled = this.participantItems.every(item => item.userVariable.value.length > 0)
        console.log('isAllFieldFilled:', isAllFieldFilled)
        this.$emit('fill', isAllFieldFilled)
        const isLoyaltyValidate = this.participantItems.every(item => {
        return this.getLoyaltyValidate(item)
      })
      this.$emit('validate', isLoyaltyValidate)
    }
  },
  methods: {
    getLoyaltyValidate (item) {
      if (item.customerVariable.mandatory) {
        return item.userVariable.value.length > 0
      }
      if (!item.customerVariable.mandatory) {
        return true
      }
    },
    onKeyDown ($event) {
      // console.log('$event', $event)
      const isLoyaltyValidate = this.participantItems.every(item => {
        // console.log('item.customerVariable.mandatory:', item.customerVariable.mandatory)
        return this.getLoyaltyValidate(item)
      })
      // console.log('isLoyaltyValidate:', isLoyaltyValidate)
      this.$emit('validate', isLoyaltyValidate)
    },
    saveItems () {
      if (this.$route.query.id !== undefined) {
      const savingItems = []
      this.participantItems.forEach(participantItem => savingItems.push(participantItem.userVariable))
      console.log('saving', this.participantItems.userVariable)
        this.webApi.put(`${process.env.VUE_APP_LOYALTY_URL}api/user_variable/`, savingItems)
      .then(response => {
        console.log('saved response.data', response.data)
      })
      // create token for saving user (staff) <- disabled
      //     this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}auth/staff/${this.$route.query.id}`)
      //     .then(response => {
      //       console.log('saved response.data for auth', response.data)
      //     })
      }
      // for users from UserProfile
      if (this.customerId && this.userProfileId) {
        const savingItems = this.participantItems.map(participantItem => participantItem.userVariable)
        this.webApi.put(`${process.env.VUE_APP_LOYALTY_URL}api/user_variable/`, savingItems)
            .then(response => {
              console.log('saved response.data', response.data)
              const isAllFieldFilled = response.data.every(item => item.value.length > 0)
              console.log('isAllFieldFilled=' + isAllFieldFilled)
              this.$emit('fill', isAllFieldFilled)
            })
      }
    }
  }
}
</script>

<style scoped>

</style>
